exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item label.stars-font.checkbox-mark{font-size:0}", ""]);

// exports
